export default "__VITE_ASSET__06722965__"